import logo from "./logo.svg";
import "./App.css";
import { Switch, Route } from "react-router-dom";
import QuestionList from "./components/dashboard/questionlist/QuestionList";
import AddQuestion from "./components/dashboard/addquestion/AddQuestion";
import AnswerPage from "./components/dashboard/answerpage/AnswerPage";
import MyQuestions from "./components/dashboard/myquestions/MyQuestions";
import InstallationGuide from "./components/dashboard/guides/InstallationGuide";
import CreateTask from "./components/dashboard/task/createtask/CreateTask";
import MyTaskList from "./components/dashboard/task/listtask/MyTaskList";
import FileUploadDemo from "./test/FileUploadDemo";
import SuccessUpload from "./test/SuccessUpload";
import DynamicFormAdding from "./components/demo/DynamicFormAdding";
function App() {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={QuestionList} />
        <Route exact path="/test" component={FileUploadDemo} />
        <Route exact path="/success" component={SuccessUpload} />
        <Route exact path="/data" component={DynamicFormAdding} />

        {/* <Route  exact path="/login" component={Login}/> */}
        <Route exact path="/dashboard" component={QuestionList} />
        <Route exact path="/dashboard/addquestion" component={AddQuestion} />
        <Route exact path="/dashboard/question/:id" component={AnswerPage} />
        <Route exact path="/dashboard/myquestions" component={MyQuestions} />
        <Route exact path="/dashboard/guides" component={InstallationGuide} />

        {/* task add */}
        <Route exact path="/dashboard/task/add" component={CreateTask} />

        {/* my tasks */}
        <Route exact path="/dashboard/task/list/:name" component={MyTaskList} />
      </Switch>
    </div>
  );
}

export default App;
